import { createSlice } from "@reduxjs/toolkit"

import { deactivateUser } from "../api/api"


const initialState={
   loading:false,
   error:{}, 
   response: null

}

const deactivationSlice= createSlice({
    name:'deactivateUser',
     initialState,

     reducers:{

     },

     extraReducers: (builder)=>{
        builder.addCase( deactivateUser.pending, (state)=>{
            state.loading = true
            state.error={}
            state.response =null

        })

        builder.addCase( deactivateUser.rejected, (state, action)=>{
            state.loading=false
            state.error= action.payload
            state.response=null
        }

        )
        builder.addCase( deactivateUser.fulfilled, (state, action)=>{
            state.loading=false
            state.error={}
            state.response= action.payload
        }
            )


     }

})

export default deactivationSlice.reducer